'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {
    case 'GET_DRESS_CHECKS':
    case 'GET_DRESS_CHECK':
      return action.payload.reduce(function (state, data) {
        return state.mergeIn(['one', data.id], (0, _immutable.fromJS)(data));
      }, state);

    case 'DELETE_DRESS_CHECKS':
      return action.payload.reduce(function (state, dresscheck) {
        return state.deleteIn(['one', dresscheck.id]);
      }, state);

    case 'CREATE_DRESS_CHECK':
    case 'UPDATE_DRESS_CHECK':
      return state.setIn(['one', action.payload.id], (0, _immutable.fromJS)(action.payload));

    case 'DELETE_DRESS_CHECK':
      var dressCheckObject = (state.getIn(['one']) || (0, _immutable.List)()).find(function (dressCheck) {
        return dressCheck.get('pid') === action.person_id;
      });
      return dressCheckObject && state.deleteIn(['one', dressCheckObject.get('id')]) || state;

    case 'GET_RESULTS':
      {
        return action.payload.reduce(function (state, data) {
          return data.dresscheck && state.setIn(['one', data.dresscheck.id], (0, _immutable.fromJS)(data.dresscheck)) || state;
        }, state);
      }

    case 'GET_ALL_EVENT_SCORES':
      {
        var dress_checks = action.payload.map(function (adj) {
          return adj.dress_checks;
        });
        return dress_checks.flat().filter(function (dress_check) {
          return dress_check !== null;
        }).reduce(function (state, dress_check) {
          return state.mergeIn(['one', dress_check.id], (0, _immutable.fromJS)(dress_check));
        }, state);
      }

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/dresschecks/index.js
// module id = 691
// module chunks = 0